<script>
  import { animate } from 'animejs'

  import { onMount } from 'svelte'
  import Container from '~/components/ui/container.svelte'

  onMount(() => {
    animate('.headline-animation .el-animated', {
      rotateX: [90, 0],
      duration: 1 * 1000,
    })
  })
</script>

<section>
  <Container>
    <div class="headline-animation min-h-[30vh] lg:h-auto lg:border-l-2 lg:border-gray-300 lg:px-8">
      <h1 class="el-animated mb-6 text-4xl lg:w-2/3 lg:text-7xl">
        Serviços de Desenvolvimento Web e Software
      </h1>
      <p class="el-animated text-md lg:w-8/12">
        Os projetos da Lutruvials são a entrega de valor real, fazemos isso com total transparência
        não somente desenvolvemos software de qualidade mais fazemos você ter conhecimentos e dicas
        de como abrir um negócio no ecossistema digital, com um orçamento amigável e versátil.
      </p>
    </div>

    <hr class="my-[48px]" />
  </Container>
</section>
